import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { EditUserRoleJson } from '../types';

export const useUpdateRole = () =>
  useMutation<ApiResponse<unknown>, unknown, EditUserRoleJson>((userRole) =>
    usersRepo.updateRole(userRole),
  );
